import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const manageRoutes: Routes = [
  {
    path: 'absences',
    loadComponent: () => import('./absences/absences.component').then((m) => m.AbsencesComponent),
    canActivate: [AuthGuard],
  },
];
